import { Box } from "@mui/material"
import { CommitteeLinkRedirection } from "@pharmupp/p3-employee-committee-domain"
import { type PropsWithChildren, forwardRef, useState } from "react"
import { ExternalLink } from "react-feather"
import { LinkContainer } from "./UserMenuLayout"

export const AdherentCommitteeIcon = () => {
  return <Box component="img" width={24} src="/icons/committee-platform.svg" />
}

export const AdherentCommitteeLink = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<{ onClick: () => void }>
>(({ onClick, children }, ref) => {
  const [openLink, setOpenLink] = useState(false)
  return (
    <>
      <LinkContainer
        ref={ref}
        onClick={() => {
          setOpenLink(true)
        }}
      >
        {children}
        <Box
          display="inline-flex"
          flex={1}
          justifyContent="flex-end"
          alignItems="center"
        >
          <ExternalLink size="1rem" />
        </Box>
      </LinkContainer>
      {openLink && (
        <CommitteeLinkRedirection
          close={() => {
            setOpenLink(false)
            onClick()
          }}
        />
      )}
    </>
  )
})
